import { render } from "./NotificationsList.vue?vue&type=template&id=342e63e9&scoped=true"
import script from "./NotificationsList.vue?vue&type=script&lang=js"
export * from "./NotificationsList.vue?vue&type=script&lang=js"

import "./NotificationsList.vue?vue&type=style&index=0&id=342e63e9&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-342e63e9"]])

export default __exports__